import { Instagram, Ghost, Music2 } from "lucide-react";
import { site, SOCIAL, genericWhatsappLink } from "@/content/liane-site.ar";
import { WhatsAppIcon } from "./WhatsAppIcon";
import lianeLogo from "@/assets/liane/liane-logo.png";

export function Footer() {
  return (
    <footer className="border-t border-l-border bg-l-accent-soft/40 pt-14 pb-28 lg:pb-14">
      <div className="container-liane grid gap-10 text-start sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <div className="flex items-center">
            <img
              src={lianeLogo}
              alt={site.brand}
              width={640}
              height={262}
              className="h-12 w-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
          <p className="mt-4 max-w-xs text-sm leading-7 text-l-muted-foreground">
            {site.footer.tagline}
          </p>
        </div>

        <nav aria-label={site.footer.quickTitle}>
          <h2 className="text-base font-bold text-l-primary">{site.footer.quickTitle}</h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-4">
            {site.nav.links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="flex min-h-11 items-center text-sm text-l-muted-foreground transition-colors hover:text-l-primary"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="text-base font-bold text-l-primary">{site.footer.socialTitle}</h2>
          <div className="mt-4 flex items-center gap-2">
            <a
              href={SOCIAL.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="grid size-12 place-items-center rounded-full border border-l-border bg-l-card text-l-primary transition-colors hover:bg-l-accent-soft"
            >
              <Instagram className="size-5" />
            </a>
            <a
              href={SOCIAL.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="grid size-12 place-items-center rounded-full border border-l-border bg-l-card text-l-primary transition-colors hover:bg-l-accent-soft"
            >
              <Music2 className="size-5" />
            </a>
            <a
              href={SOCIAL.snapchat}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Snapchat"
              className="grid size-12 place-items-center rounded-full border border-l-border bg-l-card text-l-primary transition-colors hover:bg-l-accent-soft"
            >
              <Ghost className="size-5" />
            </a>
            <a
              href={genericWhatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={site.whatsapp.fabAria}
              className="grid size-12 place-items-center rounded-full border border-l-border bg-l-card text-l-whatsapp transition-colors hover:bg-l-accent-soft"
            >
              <WhatsAppIcon className="size-5" />
            </a>
          </div>
        </div>
      </div>

      <p className="container-liane mt-10 border-t border-l-border pt-6 text-center text-sm text-l-muted-foreground">
        {site.footer.copyright}
      </p>
    </footer>
  );
}
